import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment-timezone';
import * as React from 'react';
import { connect } from 'react-redux';
import { allowedEditEventStates, CreateEventRequest, DateFormat, EventState } from 'stageclip-common';

import { DataRequestActionTypes } from '../../constants/actionTypes';
import { FormId } from '../../constants/formId';
import { NormalizedEvent } from '../../models/normalized/normalizedEvent';
import { AppSelectField } from '../form/appSelectField';
import FormModal from '../modal/formModal';

import { BaseEventForm, mapBaseEventDispatchToProps, mapBaseEventStateToProps } from './baseEventForm';

interface EditEventFormOwnProps {
  event: NormalizedEvent;
}

class EditEventForm extends BaseEventForm<EditEventFormOwnProps> {
  constructor(props: any) {
    super(props);
    this.validateForm = this.validateForm.bind(this);
  }

  preprocessDataOnSubmit = (formData: NormalizedEvent) => ({
    ...formData,
    notes: formData.notes === null ? '' : formData.notes,
  });

  protected loggedInRender() {
    return (
      <FormModal
        formId={FormId.EventForm}
        formTitle="Edit"
        buttonIcon={faPencilAlt}
        submitActionType={DataRequestActionTypes.EditEventRequested}
        reduxData={{ eventId: this.props.event.id }}
        initialValues={this.initialValues()}
        validateForm={this.validateForm}
        partialSubmit
        preprocessDataOnSubmit={this.preprocessDataOnSubmit}
      >
        {this.renderFields()}
      </FormModal>
    );
  }

  protected getFields(): JSX.Element[] {
    const editFields = super.getFields();
    editFields.splice(-3, -2, this.changeStateSelectField());

    return editFields;
  }

  private changeStateSelectField(): JSX.Element {
    return (
      this.props.event.state !== EventState.WaitingForAssets && (
        <AppSelectField name="state" label="State" options={this.getChangeStateOptions()} key="state" />
      )
    );
  }

  private getChangeStateOptions() {
    return allowedEditEventStates.map((state: EventState) => ({ label: state, value: state }));
  }

  private initialValues(): CreateEventRequest {
    const {
      assignee,
      client,
      clipConfiguration,
      invitationDate,
      deadlineDate,
      startTime,
      state,
      ...event
    } = this.props.event;

    return {
      ...event,
      assigneeId: assignee,
      clientId: client.id,
      clipConfiguration: JSON.parse(clipConfiguration),
      invitationDate: invitationDate
        ? moment(invitationDate)
            .tz(this.getClientTimezone(client.id))
            .format(DateFormat.DateTimeWithTimezone)
        : undefined,
      deadlineDate: deadlineDate
        ? moment(deadlineDate)
            .tz(this.getClientTimezone(client.id))
            .format(DateFormat.DateTimeWithTimezone)
        : undefined,
      startTime: moment(startTime)
        .tz(this.getClientTimezone(client.id))
        .format(DateFormat.DateTimeWithTimezone),
      state,
    };
  }
}

export default connect(mapBaseEventStateToProps, mapBaseEventDispatchToProps)(EditEventForm);
